export default "__VITE_ASSET__dQVtuKx3__"